<template>
  <div class="third-party-form-panel">
    <!-- Body -->
    <div class="form-body p-3">
      <b-form @submit.prevent="handleSubmit">
        <div class="section-card mb-4">
          <h6 class="section-title">Informações do Terceiro</h6>

          <b-row>
            <b-col md="6">
              <b-form-group label="Tipo" label-for="third-party-type">
                <b-form-select
                  id="third-party-type"
                  v-model="form.type"
                  :options="typeOptions"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Status" label-for="third-party-active">
                <b-form-checkbox
                  id="third-party-active"
                  v-model="form.active"
                  switch
                >
                  Ativo
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Campos para Indivíduo -->
          <div v-if="form.type === 'individuo'">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Nome Completo do Indivíduo"
                  label-for="person-name"
                >
                  <b-form-input
                    id="person-name"
                    v-model="form.name"
                    required
                    placeholder="Digite o nome do indivíduo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Email do Indivíduo"
                  label-for="person-email"
                >
                  <b-form-input
                    id="person-email"
                    v-model="form.personEmail"
                    type="email"
                    required
                    placeholder="Digite o email do indivíduo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Telefone do Indivíduo"
                  label-for="person-phone"
                >
                  <b-form-input
                    id="person-phone"
                    v-model="form.personPhone"
                    placeholder="Digite o telefone do indivíduo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="CPF/CNPJ do Indivíduo"
                  label-for="person-cpfcnpj"
                >
                  <b-form-input
                    id="person-cpfcnpj"
                    v-model="form.cpfcnpj"
                    required
                    placeholder="Digite o CPF ou CNPJ do indivíduo"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <!-- Campos para Entidade -->
          <div v-if="form.type === 'entidade'">
            <b-row>
              <b-col md="6">
                <b-form-group label="Razão Social" label-for="entity-name">
                  <b-form-input
                    id="entity-name"
                    v-model="form.name"
                    required
                    placeholder="Digite a razão social"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="CNPJ" label-for="entity-cpfcnpj">
                  <b-form-input
                    id="entity-cpfcnpj"
                    v-model="form.cpfcnpj"
                    placeholder="Digite o CNPJ (opcional)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Email da Entidade"
                  label-for="entity-email"
                >
                  <b-form-input
                    id="entity-email"
                    v-model="form.entityEmail"
                    type="email"
                    required
                    placeholder="Digite o email da entidade"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Telefone da Entidade"
                  label-for="entity-phone"
                >
                  <b-form-input
                    id="entity-phone"
                    v-model="form.entityPhone"
                    placeholder="Digite o telefone da entidade"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Nome do Responsável"
                  label-for="responsible-name"
                >
                  <b-form-input
                    id="responsible-name"
                    v-model="form.responsibleName"
                    placeholder="Digite o nome do responsável"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Email do Responsável"
                  label-for="responsible-email"
                >
                  <b-form-input
                    id="responsible-email"
                    v-model="form.responsibleEmail"
                    type="email"
                    placeholder="Digite o email do responsável"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Botões de ação -->
        <div class="form-actions d-flex justify-content-between">
          <div>
            <b-button
              v-if="isEditing"
              variant="danger"
              :disabled="submitting"
              @click="handleDelete"
            >
              <i class="fas fa-trash"></i> Excluir
            </b-button>
          </div>
          <div>
            <b-button
              type="button"
              variant="secondary"
              :disabled="submitting"
              class="mr-2"
              @click="$emit('close')"
            >
              Cancelar
            </b-button>
            <b-button type="submit" variant="primary" :disabled="submitting">
              <b-spinner v-if="submitting" small></b-spinner>
              <i v-else class="fas fa-save"></i>
              {{ isEditing ? "Atualizar" : "Salvar" }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThirdPartyForm",
  props: {
    thirdParty: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        type: "individuo",
        // Campo unificado para nome
        name: "",
        // Campos para indivíduo
        personEmail: "",
        personPhone: "",
        cpfcnpj: "",
        // Campos para entidade
        entityEmail: "",
        entityPhone: "",
        responsibleName: "",
        responsibleEmail: "",
        // Campo comum
        active: true,
      },
      typeOptions: [
        { value: "individuo", text: "Indivíduo" },
        { value: "entidade", text: "Entidade" },
      ],
    };
  },
  computed: {
    isEditing() {
      return !!this.thirdParty;
    },
  },
  watch: {
    thirdParty: {
      handler(newThirdParty) {
        if (newThirdParty) {
          this.form = {
            id: newThirdParty._id,
            type: newThirdParty.type,
            // Campo unificado para nome
            name: newThirdParty.name || "",
            // Campos para indivíduo
            personEmail: newThirdParty.personEmail || "",
            personPhone: newThirdParty.personPhone || "",
            cpfcnpj: newThirdParty.cpfcnpj || "",
            // Campos para entidade
            entityEmail: newThirdParty.entityEmail || "",
            entityPhone: newThirdParty.entityPhone || "",
            responsibleName: newThirdParty.responsibleName || "",
            responsibleEmail: newThirdParty.responsibleEmail || "",
            // Campo comum
            active: newThirdParty.active,
          };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetForm() {
      this.form = {
        type: "individuo",
        // Campo unificado para nome
        name: "",
        // Campos para indivíduo
        personEmail: "",
        personPhone: "",
        cpfcnpj: "",
        // Campos para entidade
        entityEmail: "",
        entityPhone: "",
        responsibleName: "",
        responsibleEmail: "",
        // Campo comum
        active: true,
      };
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        // Validação básica
        if (!this.form.type) {
          throw new Error("Tipo é obrigatório");
        }

        if (!this.form.name.trim()) {
          throw new Error("Nome é obrigatório");
        }

        // Validação de emails (se preenchidos)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (
          this.form.type === "individuo" &&
          this.form.personEmail &&
          this.form.personEmail.trim() &&
          !emailRegex.test(this.form.personEmail)
        ) {
          throw new Error("Email do indivíduo é inválido");
        }

        if (this.form.type === "entidade") {
          if (
            this.form.entityEmail &&
            this.form.entityEmail.trim() &&
            !emailRegex.test(this.form.entityEmail)
          ) {
            throw new Error("Email da entidade é inválido");
          }

          if (
            this.form.responsibleEmail &&
            !emailRegex.test(this.form.responsibleEmail)
          ) {
            throw new Error("Email do responsável é inválido");
          }
        }

        this.$emit("submit", { ...this.form });
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.submitting = false;
      }
    },
    async handleDelete() {
      if (!this.thirdParty) return;

      const itemName = this.thirdParty.name;

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Tem certeza que deseja excluir o terceiro "${itemName}"?`,
        {
          title: "Confirmar exclusão",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Sim, excluir",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (confirmed) {
        this.$emit("delete", this.thirdParty);
      }
    },
  },
};
</script>

<style scoped>
.third-party-form-panel {
  background: white;
  border-radius: 8px;
}

.form-body {
  max-height: 90vh;
  overflow-y: auto;
}

.section-card {
  border-radius: 8px;
  padding: 1.5rem;
}

.section-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.form-actions {
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

/* Estilização dos campos */
.form-group label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}

.form-control,
.form-select {
  border-radius: 6px;
  border: 1px solid #ced4da;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus,
.form-select:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Estilização do checkbox switch */
.custom-switch .custom-control-label::before {
  border-radius: 0.75rem;
}

.custom-switch .custom-control-label::after {
  border-radius: 0.75rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .form-actions {
    flex-direction: column;
    gap: 1rem;
  }

  .form-actions > div {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
  }
}
</style>
